import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "iframe-box list"
};
var _hoisted_2 = {
  class: "iframe-list"
};
var _hoisted_3 = {
  class: "formula-item"
};
var _hoisted_4 = {
  class: "formula-item-thumb"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "formula-item-info"
};
var _hoisted_7 = {
  class: "formula-item-name"
};
var _hoisted_8 = {
  class: "formula-item-bottom"
};
var _hoisted_9 = {
  class: "formula-item-time"
};
var _hoisted_10 = {
  key: 0,
  class: "pagination"
};
import { onMounted, ref, toRefs } from 'vue';
import { getToolList } from '@/api/excersise';
// import BaseEmpty from '@/components/Empty/index.vue'

export default {
  __name: 'list',
  props: {
    formulaListVisible: {
      // 分享浮层、弹窗显隐
      type: Boolean,
      default: false
    }
  },
  emits: ['update:formulaListVisible', 'getFormulaInfo'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    // const image = new URL('@/assets/image/empty2.png', import.meta.url).href
    var visible = ref(props.formulaListVisible);
    var closeDialog = function closeDialog() {
      emit('update:formulaListVisible', false);
    };
    var formulaList = ref([]);
    var current = ref(1);
    var pageSize = ref(24);
    var total = ref(0);
    var totalPage = ref(0);
    var getFormulaList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _res$data, _res$data2, _res$data3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getToolList({
                current: current.value,
                size: pageSize.value,
                toolType: 3
              });
            case 1:
              res = _context.v;
              if (res.data.code === 0) {
                formulaList.value = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data.records;
                total.value = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data.total;
                totalPage.value = res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data.pages;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getFormulaList() {
        return _ref2.apply(this, arguments);
      };
    }();
    var onPageChange = function onPageChange(pageNumber) {
      current.value = pageNumber;
      getFormulaList();
    };
    var handleAdd = function handleAdd(_ref3) {
      var toolCover = _ref3.toolCover,
        toolData = _ref3.toolData,
        toolName = _ref3.toolName;
      var element = {
        url: toolCover,
        latex: toolData,
        name: toolName
      };
      emit('getFormulaInfo', element);
    };
    onMounted(function () {
      console.log(2222);
      getFormulaList();
    });
    return function (_ctx, _cache) {
      var _component_t_icon = _resolveComponent("t-icon");
      var _component_t_col = _resolveComponent("t-col");
      var _component_t_row = _resolveComponent("t-row");
      var _component_t_pagination = _resolveComponent("t-pagination");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        width: "1338px",
        class: "formula-list-dialog tool-dialog",
        placement: "center",
        header: "插入公式",
        footer: false,
        attach: "body",
        "confirm-btn": null,
        "cancel-btn": null,
        "destroy-on-close": "",
        "on-close": closeDialog,
        onCloseBtnClick: closeDialog
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [formulaList.value.length ? (_openBlock(), _createBlock(_component_t_row, {
            key: 0,
            gutter: [8, 8]
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formulaList.value, function (item) {
                return _openBlock(), _createBlock(_component_t_col, {
                  key: item.id
                }, {
                  default: _withCtx(function () {
                    return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
                      src: item.toolCover
                    }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.toolName), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.createTime), 1), _createVNode(_component_t_icon, {
                      name: "add-circle",
                      size: "14px",
                      onClick: function onClick($event) {
                        return handleAdd(item);
                      }
                    }, null, 8, ["onClick"])])])])];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          })) : _createCommentVNode("", true)]), totalPage.value > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_t_pagination, {
            modelValue: current.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return current.value = $event;
            }),
            "show-jumper": "",
            "show-page-size": false,
            "page-size": pageSize.value,
            total: total.value,
            onCurrentChange: onPageChange
          }, null, 8, ["modelValue", "page-size", "total"])])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};